<!--Do NOT change this file manually, it is being generated by 'fws icons' command.-->

<template>
    <component v-bind:is="component"/>
</template>

<script>
    import startcase from 'lodash.startcase';
    import AllOrangeCircle from '../../../../assets/svg/ico-all-orange-circle.svg';
    import AllProducts from '../../../../assets/svg/ico-all-products.svg';
    import Appetizers from '../../../../assets/svg/ico-appetizers.svg';
    import ArrowLeft from '../../../../assets/svg/ico-arrow-left.svg';
    import Beef from '../../../../assets/svg/ico-beef.svg';
    import Box from '../../../../assets/svg/ico-box.svg';
    import CakesMiniatures from '../../../../assets/svg/ico-cakes-miniatures.svg';
    import Challah from '../../../../assets/svg/ico-challah.svg';
    import Chat from '../../../../assets/svg/ico-chat.svg';
    import CheckCircle from '../../../../assets/svg/ico-check-circle.svg';
    import Check from '../../../../assets/svg/ico-check.svg';
    import ChevronDown from '../../../../assets/svg/ico-chevron-down.svg';
    import ChevronRight from '../../../../assets/svg/ico-chevron-right.svg';
    import Chicken from '../../../../assets/svg/ico-chicken.svg';
    import ClockRegular from '../../../../assets/svg/ico-clock-regular.svg';
    import Comment from '../../../../assets/svg/ico-comment.svg';
    import CompleteAppetizers from '../../../../assets/svg/ico-complete-appetizers.svg';
    import Dessert from '../../../../assets/svg/ico-dessert.svg';
    import Dips from '../../../../assets/svg/ico-dips.svg';
    import Dog from '../../../../assets/svg/ico-dog.svg';
    import Drinks from '../../../../assets/svg/ico-drinks.svg';
    import DuckLambTurkey from '../../../../assets/svg/ico-duck-lamb-turkey.svg';
    import Edit from '../../../../assets/svg/ico-edit.svg';
    import Envelop from '../../../../assets/svg/ico-envelop.svg';
    import Eye from '../../../../assets/svg/ico-eye.svg';
    import Facebook from '../../../../assets/svg/ico-facebook.svg';
    import FileImage from '../../../../assets/svg/ico-file-image.svg';
    import Fish from '../../../../assets/svg/ico-fish.svg';
    import Happy from '../../../../assets/svg/ico-happy.svg';
    import HerringEgg from '../../../../assets/svg/ico-herring-egg.svg';
    import ImageRegular from '../../../../assets/svg/ico-image-regular.svg';
    import Image from '../../../../assets/svg/ico-image.svg';
    import Instagram from '../../../../assets/svg/ico-instagram.svg';
    import Kugel from '../../../../assets/svg/ico-kugel.svg';
    import Linkedin from '../../../../assets/svg/ico-linkedin.svg';
    import List from '../../../../assets/svg/ico-list.svg';
    import Location from '../../../../assets/svg/ico-location.svg';
    import Lock from '../../../../assets/svg/ico-lock.svg';
    import Minus from '../../../../assets/svg/ico-minus.svg';
    import Misc from '../../../../assets/svg/ico-misc.svg';
    import PaperGoods from '../../../../assets/svg/ico-paper-goods.svg';
    import PhoneVolume from '../../../../assets/svg/ico-phone-volume.svg';
    import Phone from '../../../../assets/svg/ico-phone.svg';
    import Pinterest from '../../../../assets/svg/ico-pinterest.svg';
    import Platters from '../../../../assets/svg/ico-platters.svg';
    import PlusCircle from '../../../../assets/svg/ico-plus-circle.svg';
    import Plus from '../../../../assets/svg/ico-plus.svg';
    import Salads from '../../../../assets/svg/ico-salads.svg';
    import Search from '../../../../assets/svg/ico-search.svg';
    import Shaboos from '../../../../assets/svg/ico-shaboos.svg';
    import Shape from '../../../../assets/svg/ico-shape.svg';
    import ShoppingBasket from '../../../../assets/svg/ico-shopping-basket.svg';
    import Side from '../../../../assets/svg/ico-side.svg';
    import Sides from '../../../../assets/svg/ico-sides.svg';
    import SortDown from '../../../../assets/svg/ico-sort-down.svg';
    import Soup from '../../../../assets/svg/ico-soup.svg';
    import Soups from '../../../../assets/svg/ico-soups.svg';
    import Spinner from '../../../../assets/svg/ico-spinner.svg';
    import Td from '../../../../assets/svg/ico-td.svg';
    import Tido from '../../../../assets/svg/ico-tido.svg';
    import TimesSlim from '../../../../assets/svg/ico-times-slim.svg';
    import Times from '../../../../assets/svg/ico-times.svg';
    import Truck from '../../../../assets/svg/ico-truck.svg';
    import Twitter from '../../../../assets/svg/ico-twitter.svg';
    import User from '../../../../assets/svg/ico-user.svg';
    import Users from '../../../../assets/svg/ico-users.svg';
    import Utensils from '../../../../assets/svg/ico-utensils.svg';
    import Watch from '../../../../assets/svg/ico-watch.svg';
    import Whatsapps from '../../../../assets/svg/ico-whatsapps.svg';

    export default {
        props: {
            iconName: {
                type: String,
                required: true
            }
        },
        components: {
            AllOrangeCircle,
            AllProducts,
            Appetizers,
            ArrowLeft,
            Beef,
            Box,
            CakesMiniatures,
            Challah,
            Chat,
            CheckCircle,
            Check,
            ChevronDown,
            ChevronRight,
            Chicken,
            ClockRegular,
            Comment,
            CompleteAppetizers,
            Dessert,
            Dips,
            Dog,
            Drinks,
            DuckLambTurkey,
            Edit,
            Envelop,
            Eye,
            Facebook,
            FileImage,
            Fish,
            Happy,
            HerringEgg,
            ImageRegular,
            Image,
            Instagram,
            Kugel,
            Linkedin,
            List,
            Location,
            Lock,
            Minus,
            Misc,
            PaperGoods,
            PhoneVolume,
            Phone,
            Pinterest,
            Platters,
            PlusCircle,
            Plus,
            Salads,
            Search,
            Shaboos,
            Shape,
            ShoppingBasket,
            Side,
            Sides,
            SortDown,
            Soup,
            Soups,
            Spinner,
            Td,
            Tido,
            TimesSlim,
            Times,
            Truck,
            Twitter,
            User,
            Users,
            Utensils,
            Watch,
            Whatsapps,

        },
        computed: {
            component() {
                return startcase(this.iconName.replace('ico-', '')).replace(' ', '');
            }
        }
    };
</script>
